/** 課程資訊頁(course.html)進入點:章節單元卡片與右上頁籤。 */
import { initPage } from '../course-common';
import { nav } from '../loading';
import { escapeHtml } from '../markdown';

const ctx = await initPage({ active: 'info' });
const c = ctx.course;
const unitList = document.getElementById('unit-list')!;

if (!c) {
  unitList.innerHTML = '缺少課程參數';
} else {
  document.getElementById('bc-course')!.textContent = c.name;
  document.title = `${c.name} - 課程資訊`;

  document.getElementById('tab-feedback')!.onclick = () => nav(`course-feedback.html?id=${c.id}`);
  document.getElementById('tab-past')!.onclick = () => nav(`course-past-exams.html?id=${c.id}`);
  document.getElementById('tab-exam')!.onclick = () => nav(`course-exam.html?id=${c.id}`);

  const meta = [
    c.department,
    `課號 ${c.code}`,
    c.course_type,
    `${c.credits}學分`,
    c.teacher_name ? `${c.teacher_name} ${c.teacher_title ?? ''}` : null,
  ].filter(Boolean).join(' · ');

  unitList.innerHTML = c.units.map((u) =>
    '<div style="background:#fff;border:1px solid #EDEDED;border-radius:14px;padding:22px 26px;'
    + 'display:flex;justify-content:space-between;align-items:center;gap:16px">'
    + '<div>'
    + `<span class="badge-purple">${escapeHtml(u.chapter_title)}</span>`
    + '<div style="font-size:19px;font-weight:600;color:#333;margin:10px 0 6px">'
    + `${escapeHtml(u.unit_no)} ${escapeHtml(u.unit_title)}</div>`
    + `<div style="font-size:14px;color:#8C8C8C">${meta}</div>`
    + '</div>'
    + '<div style="display:flex;gap:10px;flex-shrink:0">'
    + `<a class="btn-ghost" style="text-decoration:none" href="course-slides.html?id=${c.id}">簡報</a>`
    + `<a class="btn-outline" style="text-decoration:none" href="course-note.html?id=${c.id}&unit=${u.id}">筆記</a>`
    + `<a class="btn-primary" style="text-decoration:none" href="course-quiz.html?id=${c.id}&unit=${u.id}">測驗</a>`
    + '</div>'
    + '</div>').join('');
}
